import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {InsuranceService, ImportReferenceService} from 'application/import-reference/services';
import { ImportReferenceTypeService } from 'application/import-reference-type/services';
import { BaasicDropdownStore, BasicQueryCheckboxStore } from 'core/stores';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import {GridBooleanCell} from 'core/components';
import { action, observable } from 'mobx';
import _ from 'lodash';

@applicationContext
class ImportReferenceViewStore extends BaseListViewStore {
    @observable accessor downloadUrl = null;
    constructor(rootStore) {
        const importReferenceService = new ImportReferenceService(rootStore.application.baasic.apiClient);
        const insuranceService = new InsuranceService(rootStore.application.baasic.apiClient);
        const importReferenceTypeService = new ImportReferenceTypeService(rootStore.application.baasic.apiClient);
        const permissions = rootStore.userStore.user.permissions;
        let actions = {};
        let routes = {};

        if(permissions.importReferenceSection !== undefined && permissions.importReferenceSection.includes("Full")){
            actions = {
                onDelete: (item) => this.deleteResource(item),
                onEdit: async (item) => routes.edit(item)
            };
            routes = {
                create: () => rootStore.routerStore.goTo(
                    'master.app.main.import-reference.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i => i.id === item.id,() => item.name);
                    return rootStore.routerStore.goTo(
                        'master.app.main.import-reference.edit',
                        { id: item.id }
                    )
                },
                upload: () => this.rootStore.routerStore.goTo(
                    'master.app.main.import-reference.upload'
                ),
            };
        }

        super(rootStore, {
            name: 'import-reference',
            autoInit: true,
            routes: routes,
            actions: () => {
                return {
                    find: async (params) => {
                        var importReferenceTypeIds = this.importReferenceTypeStore && this.importReferenceTypeStore.value && _.map(this.importReferenceTypeStore.value, (i=>{return i.id}));
                        if(importReferenceTypeIds && importReferenceTypeIds.length>0){
                            importReferenceTypeIds = importReferenceTypeIds.join(",");
                        }else{
                            importReferenceTypeIds = null;
                        }
                        var showOnlyActive = (this.inactiveQueryCheckboxStore != null && this.inactiveQueryCheckboxStore.value != null) ? (this.inactiveQueryCheckboxStore.value === true ? null : true) : null;
                        const response = await importReferenceService.find({
                            ...params,
                            embed: 'Insurance,ImportReferenceType',
                            isActive: showOnlyActive,
                            importReferenceTypeIds: importReferenceTypeIds,
                        });

                        response.data.item = response.data.item.map(i => {
                            return {
                                ...i,
                                insurance: i.insurance && i.insurance.name,
                                importReferenceType: i.importReferenceType && i.importReferenceType.name
                            };
                        });
                        this.onFindSuccess(params);
                        return response.data;
                    },
                    delete: async (item) => {
                        await importReferenceService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.importReferenceService = importReferenceService;

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                 {
                    key: 'name',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.NAME',
                },
                {
                    key: 'importReferenceType',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.IMPORT_REFERENCE_TYPE',
                    width: 300
                },
                {
                    key: 'description',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.DESCRIPTION',
                    width: 200
                },
                {
                    key: 'insurance',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.INSURANCE',
                    width: 250
                },
                {
                    key: 'isBillableToMedicare',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.ISBILLABLETOMEDICARE',
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    headerClassName: "center",
                    width: 200
                },
                {
                    key: 'isActive',
                    title: 'IMPORT_REFERENCE.LIST.COLUMNS.ISACTIVE',
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    headerClassName: "center",
                    width: 100
                },
            ]),
            actions: actions
        }));

        this.insuranceStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await insuranceService.find({ searchQuery: term, rpp: 10, sort: 'name|asc'});
                return response.data.item;
            }
        });

        this.importReferenceTypeStore = new BaasicDropdownStore({
			filterable: true,
            multi: true
		}, {
			fetchFunc: async(term) => {
				const response = await importReferenceTypeService.find({
					searchQuery: term,
					rpp: 25,
                    sort: 'name|asc'
			});
                return response.data.item;
			}
		});

        this.inactiveQueryCheckboxStore = new BasicQueryCheckboxStore();
        this.queryUtility.filter.toggle('inActive');
        this.inactiveQueryCheckboxStore.setValue(true);

        this.queryUtility.onResetFilter = () => {
            this.inactiveQueryCheckboxStore.reset(true);

            this.importReferenceTypeStore.setValue(null);
            this.importReferenceTypeStore.filterTerm = "";

            this.insuranceStore.setValue(null);
            this.insuranceStore.filterTerm = "";
            
        }
    } 

    @action.bound
    onFindSuccess() {
        const parameters = this.queryUtility.plainFilter;
        this.downloadUrl = `${this.importReferenceService.getDownloadUrl(parameters)}?contentDisposition=attachment&token=${
            this.rootStore.authStore.token.tokenUrl
        }&ttype=${
            this.rootStore.authStore.token.type}`
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('IMPORT_REFERENCE.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default ImportReferenceViewStore;
